export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/courseFill.0941f5dc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};